<template>
  <el-dialog
    title="修改账户信息"
    :visible.sync="dialogVisible"
    width="500px"
    :before-close="handleClose"
    @close="handleClose"
  >
    <el-form
      ref="editForm"
      :model="form"
      :rules="rules"
      label-width="150px"
      v-loading="loading"
    >
      <el-form-item label="公司名称：" prop="companyName">
        <el-input
          v-model="form.companyName"
          placeholder="请输入公司名称"
          maxlength="50"
        ></el-input>
        <div v-if="companyNameError" class="error-tip">{{ companyNameError }}</div>
      </el-form-item>

      <el-form-item label="营业执照照片：">
        <div v-if="form.licenseFileUrl">
          <el-button size="small" @click="viewLicense">查看</el-button>
          <el-upload
            class="upload-demo"
            :action="uploadUrl"
            :headers="uploadHeaders"
            :on-success="handleUploadSuccess"
            :on-error="handleUploadError"
            :show-file-list="false"
            accept=".jpg,.jpeg,.png,.pdf"
            name="fileVal"
            style="margin-left: 10px;"
          >
            <el-button size="small" type="primary">重新上传</el-button>
          </el-upload>
        </div>
        <div v-else>
          <el-upload
            class="upload-demo"
            :action="uploadUrl"
            :headers="uploadHeaders"
            :on-success="handleUploadSuccess"
            :on-error="handleUploadError"
            :show-file-list="false"
            accept=".jpg,.jpeg,.png,.pdf"
            name="fileVal"
          >
            <el-button size="small" type="primary">上传</el-button>
          </el-upload>
        </div>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getCompanyInfo, updateCompany, createCompany } from '@/api/member'

export default {
  name: 'EditSingleUser',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    companyInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    // 公司名称验证规则
    const validateCompanyName = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入公司名称'))
        return
      }
      
      // 公司名格式验证（只允许中文、英文括号）
      if (!/^[\(\)（）\u4e00-\u9fa5]{1,64}$/.test(value)) {
        callback(new Error('公司名格式不正确'))
        return
      }
      
      callback()
    }
    
    return {
      dialogVisible: this.visible,
      loading: false,
      submitting: false,
      form: {
        companyId: '',
        companyName: '',
        licenseFileUrl: '',
        userId: ''
      },
      // 保存初始化时的原始值，用于比较是否修改
      originalValues: {
        companyName: '',
        licenseFileUrl: ''
      },
      rules: {
        companyName: [
          { required: true, validator: validateCompanyName, trigger: 'blur' }
        ]
      },
      companyNameError: '',
      uploadUrl: process.env.VUE_APP_FILE_UPLOAD_URL || 'http://test.rbbaotong.com/res/file/upload',
      uploadHeaders: {
        'Authorization': 'Bearer ' + (localStorage.getItem('jubao_admin_token') || localStorage.getItem('jubao_admin') || '')
      }
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        this.$nextTick(() => {
          this.initData()
        })
      }
    }
  },
  methods: {
    // 初始化数据
    async initData() {
      this.resetForm()
      
      if (this.companyInfo) {
        this.form.companyId = this.companyInfo.company_id || ''
        this.form.companyName = this.companyInfo.company_name || ''
        this.form.userId = this.companyInfo.id || ''
        
        // 获取营业执照照片
        if (this.form.companyId) {
          try {
            const res = await getCompanyInfo({ id: this.form.companyId })
            if (res.err_code === 0) {
              this.form.licenseFileUrl = res.data.license_file_url || ''
            }
          } catch (error) {
            console.error('获取公司信息失败:', error)
          }
        }
        
        // 保存初始化时的原始值
        this.originalValues.companyName = this.form.companyName
        this.originalValues.licenseFileUrl = this.form.licenseFileUrl
      }
    },

    // 重置表单
    resetForm() {
      this.$refs.editForm && this.$refs.editForm.resetFields()
      this.form = {
        companyId: '',
        companyName: '',
        licenseFileUrl: '',
        userId: ''
      }
      this.originalValues = {
        companyName: '',
        licenseFileUrl: ''
      }
      this.companyNameError = ''
    },

    // 查看营业执照
    viewLicense() {
      if (this.form.licenseFileUrl) {
        window.open(this.form.licenseFileUrl, '_blank')
      }
    },

    // 上传成功回调
    handleUploadSuccess(response, file, fileList) {
      if (response.err_code === 0) {
        this.form.licenseFileUrl = response.data
        this.$message.success('上传成功')
      } else {
        this.$message.error(response.err_msg || '上传失败')
      }
    },

    // 上传失败回调
    handleUploadError(err, file, fileList) {
      this.$message.error('上传失败')
    },

    // 关闭对话框
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },

    // 提交表单
    handleSubmit() {
      this.$refs.editForm.validate(async (valid) => {
        if (valid) {
          // 检查是否更改
          const isCompanyNameChanged = this.originalValues.companyName !== this.form.companyName
          const isLicenseFileChanged = this.originalValues.licenseFileUrl !== this.form.licenseFileUrl
          
          if (!isCompanyNameChanged && !isLicenseFileChanged) {
            this.$message.info('未做修改')
            this.handleClose()
            return
          }
          
          this.submitting = true
          try {
            let res
            const params = {
              id: this.form.companyId,
              user_id: this.form.userId,
              name: this.form.companyName
            }
            
            // 如果有上传的营业执照照片，则添加到参数中
            if (this.form.licenseFileUrl) {
              params.license_file_url = this.form.licenseFileUrl
            }
            
            // 根据是否有公司ID决定是更新还是创建
            if (this.form.companyId) {
              // 更新公司信息
              res = await updateCompany(params)
            } else {
              // 创建公司
              res = await createCompany(params)
            }
            
            if (res.err_code === 0) {
              this.$message.success('保存成功')
              // 更新原始值
              this.originalValues.companyName = this.form.companyName
              this.originalValues.licenseFileUrl = this.form.licenseFileUrl
              this.$emit('success')
              this.handleClose()
            } else if (res.err_code === 1201) {
              this.$message.error('公司已存在')
            } else if (res.err_code === 1002) {
              this.$message.error('没有权限')
            } else if (res.err_code === 1062) {
              this.$message.error('公司名称已存在')
            } else {
              this.$message.error(res.err_msg || '保存失败')
            }
          } catch (error) {
            console.error('保存失败:', error)
            this.$message.error('保存失败')
          } finally {
            this.submitting = false
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-footer {
  text-align: center;
}

.error-tip {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  text-align: left;
}
</style>